import React, { FC } from 'react';
import styled from 'styled-components';

const Dot = styled.span`
  margin: 0 var(--spacing-03);
`;

export const SummaryTabTitle: FC<{
  count?: number;
  title: string;
}> = ({ title, count }) => (
  <>
    <span>{title}</span>
    {count && (
      <>
        <Dot>•</Dot>
        {count}
      </>
    )}
  </>
);
